module.exports = __webpack_public_path__ + "static/media/median-graph-mobile.7b31ef70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/median-graph-mobile.png
// module id = ./src/assets/median-graph-mobile.png
// module chunks = 0